import { cva, type VariantProps } from 'class-variance-authority'

import { ActionPrimitive, type ActionPrimitiveProps } from '@/components/ui/action-primitive'
import { cn } from '@/lib/utils'

const actionRowVariants = cva(
  'flex w-full min-w-0 cursor-pointer items-center text-left outline-none transition-colors hover:bg-muted/30 focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-ring disabled:cursor-default disabled:text-muted-foreground disabled:hover:bg-transparent',
  {
    variants: {
      padding: {
        none: '',
        compact: 'px-2 py-1.5',
        default: 'px-4 py-3',
      },
      radius: {
        control: 'rounded-md',
        none: 'rounded-none',
      },
    },
    defaultVariants: {
      padding: 'default',
      radius: 'control',
    },
  }
)

export type ActionRowProps = ActionPrimitiveProps & VariantProps<typeof actionRowVariants>

function ActionRow({
  asChild = false,
  className,
  padding = 'default',
  radius = 'control',
  type = 'button',
  ...props
}: ActionRowProps) {
  return (
    <ActionPrimitive
      {...props}
      asChild={asChild}
      type={type}
      data-slot="action-row"
      className={cn(actionRowVariants({ padding, radius }), className)}
    />
  )
}

export { ActionRow, actionRowVariants }
